import React from "react";

import { CheckCircleOutlined } from "@ant-design/icons";
import { SiteReadable as Site } from "../../../services/client";
import ErrorMessage from "../../util-components/ErrorMessage";

type StepTwoProps = {
  site?: Site;
};

export const StepTwo: React.FC<StepTwoProps> = ({ site }) => {
  if (!site) {
    return <ErrorMessage />;
  }

  return (
    <div className="flex flex-col items-center text-center space-y-4">
      <div>
        <CheckCircleOutlined className="mt-4 text-primary-500 text-4xl" />
        <h2 className="text-xl font-semibold mt-2">
          Site Created Successfully!
        </h2>
        <p className="text-gray-600">
          Congratulations! Your site <strong>{site.name}</strong> has been
          created.
        </p>
      </div>

      <div className="bg-gray-100 p-4 rounded-md shadow-md w-full max-w-md">
        <h3 className="text-lg font-semibold mb-2">MQTT Setup Instructions</h3>
        <p>Set up your MQTT client to the cluster at</p>
        <code className="block bg-gray-200 text-blue-600 p-2 rounded-md mt-2">
          {site.connections?.mqtt.cluster}
        </code>
        <p>start sending energy measurments to the following topic:</p>
        <code className="block bg-gray-200 text-blue-600 p-2 rounded-md mt-2 break-words">
          {site.connections?.mqtt.energy_measurement_topic}
        </code>
        <p>and transactions to</p>
        <code className="block bg-gray-200 text-blue-600 p-2 rounded-md mt-2 break-words">
          {site.connections?.mqtt.transaction_topic}
        </code>
      </div>
    </div>
  );
};
